import { createFileRoute, redirect } from '@tanstack/react-router';

// Vista ritirata il 12-10-2026: doppione del Cruscotto. Tiene vivi i vecchi link.
export const Route = createFileRoute('/_app/tasks/capacity')({
  beforeLoad: () => { throw redirect({ to: '/tasks/dashboard', replace: true }); },
});
